export const ORDER_STATUS_OPEN = 'OPEN';
export const ORDER_STATUS_CLOSED = 'CLOSED';
export const ORDER_STATUS_CANCELED = 'CANCELED';

export const ORDER_STATUS_TO_LABEL = {
  [ORDER_STATUS_OPEN]: 'Open',
  [ORDER_STATUS_CLOSED]: 'Closed',
  [ORDER_STATUS_CANCELED]: 'Canceled',
};
